// src/admin/pages/AssignTenantModal.jsx
import React, { useState } from 'react';
import AdminModal from '../components/AdminModal.jsx';
import { assignUserToTenant } from '../adminApi.js';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '8px',
  border: '1px solid rgba(0,0,0,0.12)', background: '#ffffff',
  color: '#1d1d1f', fontSize: '14px', boxSizing: 'border-box',
  outline: 'none', fontFamily: "'DM Sans', sans-serif",
};

const labelStyle = {
  display: 'block', color: '#6c6c6d', fontSize: '13px', marginBottom: '6px', fontWeight: 500,
};

const ROLES = ['viewer', 'editor', 'admin'];

export default function AssignTenantModal({ open, onClose, userEmail, availableTenants, onAssigned }) {
  const [tenantId, setTenantId] = useState('');
  const [role, setRole] = useState('editor');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!tenantId) { setError('Seleziona un tenant'); return; }
    setError('');
    setLoading(true);
    try {
      await assignUserToTenant(tenantId, userEmail, role);
      setTenantId('');
      setRole('editor');
      onAssigned();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setTenantId('');
    setRole('editor');
    setError('');
    onClose();
  }

  return (
    <AdminModal open={open} onClose={handleClose} title="Assegna a tenant" width={420}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Tenant</label>
          <select value={tenantId} onChange={e => setTenantId(e.target.value)} style={inputStyle}>
            <option value="">— Seleziona —</option>
            {availableTenants.map(t => (
              <option key={t.id} value={t.id}>{t.display_name}</option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={labelStyle}>Ruolo</label>
          <select value={role} onChange={e => setRole(e.target.value)} style={inputStyle}>
            {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        {error && (
          <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '13px' }}>
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
            background: loading ? '#ccc' : '#E8002D', color: '#fff',
            fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? 'Assegnazione...' : 'Assegna'}
        </button>
      </form>
    </AdminModal>
  );
}
